export enum CameraErrorCode {
  NOT_SUPPORTED = 'NOT_SUPPORTED',
  PERMISSION_DENIED = 'PERMISSION_DENIED',
  NOT_FOUND = 'NOT_FOUND',
  NOT_READABLE = 'NOT_READABLE',
  ABORTED = 'ABORTED',
  UNKNOWN = 'UNKNOWN',
}

export interface CameraError {
  code: CameraErrorCode;
  message: string;
}

const NO_CAMERA_MESSAGE =
  'Es necesario contar con una cámara para realizar esta operación. Por favor permitir o instalar una cámara en este dispositivo o ingresar desde un dispositivo móvil.';

export function mapCameraError(error: unknown): CameraError {
  const name = (error as DOMException)?.name;
  switch (name) {
    case 'NotAllowedError':
    case 'SecurityError':
      return {
        code: CameraErrorCode.PERMISSION_DENIED,
        message: 'Necesitamos tu permiso para usar la cámara. Por favor, permití el acceso e intentá de nuevo.',
      };
    case 'NotFoundError':
    case 'OverconstrainedError':
      return { code: CameraErrorCode.NOT_FOUND, message: NO_CAMERA_MESSAGE };
    case 'NotReadableError':
      return {
        code: CameraErrorCode.NOT_READABLE,
        message: 'La cámara está siendo utilizada por otra aplicación. Cerrala e intentá nuevamente.',
      };
    case 'AbortError':
      return { code: CameraErrorCode.ABORTED, message: 'Se canceló el acceso a la cámara.' };
    default:
      return { code: CameraErrorCode.UNKNOWN, message: 'No se pudo acceder a la cámara.' };
  }
}

export function getNoCameraMessage(): string {
  return NO_CAMERA_MESSAGE;
}
